<script>
  export let change = 0;
  export let data = [];

  export let width = 110;
  export let height = 30;

  export let chartFill = '';
  export let chartLineColor = '';

  const scale = 2;
  const offset = 0.15;

  let path = '';
  let area = '';

  function genChartData(data) {
    const count = data.length;
    if (count < 1) {
      return {path: '', area: ''};
    }

    const W = width * scale;
    const H = height * scale;
    const w = W / count;

    const max = Math.max.apply(null, data);
    const min = Math.min.apply(null, data);

    const polygon = data
      .map((p, index) => {
        const x = index * w;
        const y = max === min ? 0 : H * (1 - offset) * (1 - (p - min) / (max - min));
        return `${x.toFixed(3)},${y.toFixed(3)}`;
      })
      .join('L');
    const path = polygon ? `M${polygon}` : '';
    return {path, area: `${path}L${W},${H}L0,${H}Z`};
  }

  $: {
    const chartData = genChartData(data);
    path = chartData.path;
    area = chartData.area;
  }

  function generateChartLineColor(chartLineColor, change) {
    if (chartLineColor !== '') {
      return chartLineColor;
    }

    return change > 0 ? '#32F469' : '#f61a14';
  }

  function generateChartFillId(chartFill, change) {
    if (chartFill !== '') {
      return chartFill;
    }

    const trendType = change > 0 ? 'up' : 'down';
    return `trend-${trendType}-fill`;
  }
</script>

<style>
  .line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
  }
</style>

<svg {width} {height} viewBox="0 0 {width * 2} {height * 2}">
  <defs>
    <linearGradient id="trend-up-fill" x1="0" x2="0" y1="0" y2="1">
      <stop offset="0%" stop-color="#a7ffe9" stop-opacity="0.62" />
      <stop offset="90%" stop-color="#a7ffe9" stop-opacity="0.2" />
      <stop offset="100%" stop-color="#fff" stop-opacity="0.1" />
    </linearGradient>
    <linearGradient id="trend-down-fill" x1="0" x2="0" y1="0" y2="1">
      <stop offset="0%" stop-color="#fd9491" stop-opacity="0.47" />
      <stop offset="90%" stop-color="#fd9491" stop-opacity="0.1" />
      <stop offset="100%" stop-color="#fff" stop-opacity="0.05" />
    </linearGradient>
    <linearGradient id="trend-blue-fill" x1="0" x2="0" y1="0" y2="1">
      <stop stop-color="rgba(0, 85, 255, 0.59)" stop-opacity="0.26" />
      <stop offset="1" stop-color="rgba(0, 85, 255, 0.00)" stop-opacity="0" />
    </linearGradient>
  </defs>
  <g fill="transparent">
    <path class="line" d={path} stroke-width="2" stroke={generateChartLineColor(chartLineColor, change)} />
  </g>
</svg>
